module.exports = __webpack_public_path__ + "img/worksbot_img19121306.ee18f566.jpg";